import microuniversoApi from "app/api/microuniversoApi";
import { ICliente } from "app/types/ICliente";
import { tratamentoErroPadrao } from "app/use-cases";
import { FormikErrors } from "formik";
import globalMU from "globalMU";
import React from "react";
import { DadosBasicosClienteNaoCadastrado } from "./DadosBasicosClienteNaoCadastrado";

export type DadosBasicosClienteNaoCadastradoContainerProps = {
  cliente: ICliente
  somenteLeitura: boolean
  formularioValidado: boolean
  onErrorValidacao: (erros: FormikErrors<ICliente>) => void;
  manterDadosTemporariosCliente: (Cliente: ICliente) => void;
  onValidarFormulario: (formularioValidado: boolean) => void;
  dadosBasicosClienteNaoCadastrado: ICliente
  permitirAlterarDadosBasicos: boolean
}

export const DadosBasicosClienteNaoCadastradoContainer = (props: DadosBasicosClienteNaoCadastradoContainerProps) => {


  const onAlteradoCPFCNPJ = async (cpfCnpj: string) => {
    try {
      globalMU.blockUI();
      const obrigatorioInformarEmail = await microuniversoApi.Cliente.obrigatorioInformarEmail(cpfCnpj)

      const tipoPessoa = await microuniversoApi.Comum.ObterTIpoPessoa(cpfCnpj, true)

      tipoPessoa == "J" || tipoPessoa == "F" ?

        props.manterDadosTemporariosCliente({
          ...props.dadosBasicosClienteNaoCadastrado,
          CpfCnpj: cpfCnpj,
          PessoaJuridica: tipoPessoa == "J",
          EmailObrigatorio: obrigatorioInformarEmail
        })
        : (
          globalMU.showErrorMessage(tipoPessoa),
          props.manterDadosTemporariosCliente({
            ...props.dadosBasicosClienteNaoCadastrado,
            CpfCnpj: ""
          })
        )

    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  }

  const manterDadosTemporarios = (dados: ICliente) => props.manterDadosTemporariosCliente(dados);

  return (
    <>
      <DadosBasicosClienteNaoCadastrado
        somenteLeitura={props.somenteLeitura}
        dadosBasicosClienteNaoCadastrado={props.dadosBasicosClienteNaoCadastrado}
        formularioValidado={props.formularioValidado}
        permitirAlterarDadosBasicos={props.permitirAlterarDadosBasicos}
        onErrorValidacao={props.onErrorValidacao}
        onValidarFormulario={props.onValidarFormulario}
        manterDadosTemporarios={manterDadosTemporarios}
        onAlteradoCPFCNPJ={onAlteradoCPFCNPJ}
      />
    </>
  );
};

